import amazon_gift from "../../../assets/images/amazon-giftcard.jpg";
import number_one from "../../../assets/images/number-one.jpg";
import three_trophy from "../../../assets/images/three-trophy.avif";

import mcAlisters from "../../../assets/images/icons/catering-icons/mcAlisters-logo.svg";
import schlotzskys from "../../../assets/images/icons/catering-icons/schlotzskys-logo.png";

export const SIDE_BANNER_CARD_INFO = [
  {
    heading: "Earn Amazon.com Gift Cards",
    body: "Redeem points as Amazon.com Gift Card. Its way better than restaurant points that you can redeem only at the restaurant.",
    cardImage: amazon_gift,
  },
  {
    heading: "One Login For All Catering Rewards",
    body: "Earn points for catering orders from restaurants everywhere. One login to remember to track & redeem them all.",
    cardImage: number_one,
  },
  {
    heading: "Discover High Paying Restaurants",
    body: "Discover restaurants offering higher catering rewards. Boost earnings with bigger orders, repeat orders, higher total spend, special offers & more…",
    cardImage: three_trophy,
  },
];

export const SIDE_BANNER_COMPANY_LOGO = [
  { logo: mcAlisters, link: "https://www.mcalistersdeli.com/", text: "McAlister's Deli" },
  { logo: schlotzskys, link: "https://www.schlotzskys.com/", text: "Schlotzsky's" },
];
